import React from 'react';
import "./Stick.css";

const stickPositions = [
  { left: "158px", bottom: "164px", rotate: "-152deg", scaleX: "0.8", zIndex: "12" },
  { left: "180px", bottom: "30px", rotate: "20deg", scaleX: "0.9", zIndex: "inherit" },
  { left: "400px", bottom: "38px", rotate: "170deg", scaleX: "0.9", zIndex: "inherit" },
  { left: "370px", bottom: "150px", rotate: "80deg", scaleX: "0.9", zIndex: "20" },
];

interface StickProps {
  index: number;
}

export default function Stick({ index }: StickProps) {
  const { left, bottom, rotate, scaleX, zIndex } = stickPositions[index];

  return (
    <div
      className="stick absolute rounded-md bg-brown-700"
      style={{
        left: left,
        bottom: bottom,
        width: "68px",
        height: "20px",
        borderRadius: "10px",
        background: "#781e20",
        transform: `rotate(${rotate}) scaleX(${scaleX})`,
        transformOrigin: "center center",
        boxShadow: "0 0 2px 1px rgba(0, 0, 0, 0.1)",
        zIndex: zIndex,
      }}
    >
      {/* Optional: Add a small "tip" element here */}
    </div>
  );
}